// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of, concat } from "rxjs"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Slice from "../slices/timeline"
import * as Actions from "../actions"
import { grpc } from "../../../app/rpc/executor"
import { showSnackBar } from "../../snackbar/actions"
import { timesheetFieldClient } from "../../../app/rpc/client"
import {
  BatchGetTimesheetFieldConfigsRequest,
  BatchGetTimesheetFieldConfigsResponse
} from "../../../generated/wisetime/site/timesheetfield/v1/timesheet_field_pb"

type BatchGetTimesheetFieldConfigsRpc = (request: BatchGetTimesheetFieldConfigsRequest) => Observable<BatchGetTimesheetFieldConfigsResponse>

export const batchGetTimesheetFieldConfigs = (batchGetTimesheetFieldConfigsRpc: BatchGetTimesheetFieldConfigsRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.batchGetTimesheetFieldConfigs.match),
      mergeMap(action => of(action.payload)
        .pipe(
          mergeMap(batchGetTimesheetFieldConfigsRpc),
          map(t => t.toObject().timesheetFieldConfigsList),
          map(Slice.setTimesheetFieldConfigs),
          catchError(() => concat([
            Actions.batchGetTimesheetFieldConfigsFailed(action.payload),
            showSnackBar({
              message: t({
                id: "msg_batch_get_timesheet_field_configs_failed",
                message: "Failed to load timesheet field details. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com.",
              }),
              messageType: "ERROR",
            })
          ])),
        )
      ),
    )

const batchGetTimesheetFieldConfigsRpc = (request: BatchGetTimesheetFieldConfigsRequest): Observable<BatchGetTimesheetFieldConfigsResponse> =>
  grpc(() => timesheetFieldClient.batchGetTimesheetFieldConfigs(request, null))

export default batchGetTimesheetFieldConfigs(batchGetTimesheetFieldConfigsRpc)
